import { OrderItem, RewardWallet, StoreMenu } from "store/slices/tOrderTypes";

 /**
   * Transforming the modifiers list to have show only one entry for each
   * bulk modifier group as per business requirement
   */
export function getUniqueBulkModifierOptions(cartItem: OrderItem) {
    const processedGroupSetIds = new Set<string>();

    return cartItem.modifiers.filter((modifierOption) => {
        if (!modifierOption.bulkModifierGroupSetId) {
            return true;
        }

        if (processedGroupSetIds.has(modifierOption.bulkModifierGroupSetId)) {
            return false;
        }

        processedGroupSetIds.add(modifierOption.bulkModifierGroupSetId);
        return true;
    });
}

export function formatPrice(price:number) {
  return `${(price ?? 0).toFixed(2)}`;
}

export function getModifierLabel(modifierName:string, modifierOptionName:string) : string {
    let modfierLabel = modifierOptionName;
    switch (modifierOptionName.toLowerCase()) {
        case 'small':
        case 'medium':
        case 'large':
            modfierLabel = `${modifierName}: ${modifierOptionName}`;
            break;
        case 'yes':
        case 'no':
            modfierLabel = `${modifierName}? ${modifierOptionName}`;
            break;
        default:
            modfierLabel = modifierOptionName;
    }
    return modfierLabel;
}

export function getFilteredCategoriesByRewards(
  categories: StoreMenu["categories"] = [],
  wallets: RewardWallet[] | null = [],
  walletCode = "",
) {
  const selectedReward = wallets?.find(
    (reward) => `${reward.walletCode}` === walletCode,
  );
  if (selectedReward?.categoryItemCodes.length) {
    const categoryCodes = selectedReward.categoryItemCodes.map(
      (itemCode) => itemCode.categoryCode,
    );
    return categories
      .map(({ menuItems, ...category }) => ({
        ...category,
        menuItems: menuItems.filter((menuItem) => categoryCodes.includes(menuItem.multiLocationId)),
      }))
      .filter((category) => category.menuItems.length > 0);
  }
  return categories;
}
